module.exports = __webpack_public_path__ + "static/media/woman (1).b269a0f4.png";